module.exports = __webpack_public_path__ + "img/logo_white.f2730525.png";